
const digest = '5b6156cb12df13a211240dd543bc6deffc76b0bb6845ff1763e362b3be3947b1';
const classes = {"footerContent":"_footerContent_1omh4_1"};
const css = `._footerContent_1omh4_1 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  margin: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  